import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=71fffd47&scoped=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"
import style0 from "./Start.vue?vue&type=style&index=0&id=71fffd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fffd47",
  null
  
)

export default component.exports